import { IGatsbyImageData } from "gatsby-plugin-image";

// Import Luxon
import { DateTime } from 'luxon';

/**
 * suggested image sizes: 
 * normal video card poster image: 668x376
 * featured video card poster image: 1194x676
 */
export type ImageContentCardData = {
    id?: string;
    /**
     * suggested size: 668x376
     */
    cardImage?: IGatsbyImageData;
    cardImageAlt?: string;
    label?: string;
    headline: string;
    date?: DateTime;
    subtext?: string;
    buttonText?: string;
    buttonUrl?: string;
    buttonUrlTarget?: string;
    columns?: number;
    videoUrl?: string;
    videoThumbnailUrl?: string;
    videoThumbnailHeight?: number;
    videoThumbnailWidth?: number;
    videoThumbnailAlt?: string;
};

/**
 * Sorts an array of ImageContentCardData by date and then by headline.
 * Cards with null dates will come after items with dates.
 * 
 * @param cards Array of ImageContentCardData
 * @returns Sorted array of ImageContentCardData
 */
export const sortImageContentCards = (cards: ImageContentCardData[]): ImageContentCardData[] => {
    return cards.sort((a, b) => {
        if (a.date && b.date) {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            // If dates are equal, sort by headline
            return a.headline.localeCompare(b.headline);
        } else if (a.date) {
            return -1;
        } else if (b.date) {
            return 1;
        }
        return a.headline.localeCompare(b.headline);
    });
};
